export const dataMonitoreo2025 = [
  {
    id: 1,
    yearBoletin: "2025",
    monthBoletin: "MAYO",
    nameBoletin: "Informes de Monitoreo con perspectiva de Género.",
  },
  {
    id: 2,
    yearBoletin: "2025",
    monthBoletin: "MAYO",
    nameBoletin: "Primer Informe con Perspectiva de Género a Medios de Comunicación Masiva Impresos, Digitales y Programas que difunden noticias por Radio y Televisión para el Proceso Local Extraordinario  2024-2025.",
  },
  {
    id: 3,
    yearBoletin: "2025",
    monthBoletin: "MAYO",
    nameBoletin: "Segundo Informe con Perspectiva de Género a Medios de Comunicación Masiva Impresos, Digitales y Programas que difunden noticias por Radio y Televisión para el Proceso Local Extraordinario  2024-2025.",
  },
  {
    id: 4,
    yearBoletin: "2025",
    monthBoletin: "MAYO",
    nameBoletin: "Tercer Informe con Perspectiva de Género a Medios de Comunicación Masiva Impresos, Digitales y Programas que difunden noticias por Radio y Televisión para el Proceso Local Extraordinario  2024-2025.",
  },
    {
    id: 5,
    yearBoletin: "2025",
    monthBoletin: "JUNIO",
    nameBoletin: "Informe Final con Perspectiva de Género a Medios de Comunicación Masiva Impresos, Digitales y Programas que difunden noticias por Radio y Televisión para el Proceso Local Extraordinario  2024-2025.",
  },
];
